{
  "version": 1,
  "asset_id": "970b61f7-e23a-4528-bf27-77385673b751",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/970b61f7-e23a-4528-bf27-77385673b751/candidhealth-240.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/970b61f7-e23a-4528-bf27-77385673b751/candidhealth-240.webp",
  "original_filename": "candidhealth-240.webp",
  "size": 6056,
  "content_type": "image/webp",
  "created_at": "2026-09-18T14:38:49Z"
}
